import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";

const CheckCircle = () => (
  <svg width="65" height="65" viewBox="0 0 65 65" fill="none">
    <circle cx="32.5" cy="32.5" r="30.5" stroke="#FFFFFF" strokeWidth="3" />
    <path d="M20 33l9 9 16-18" stroke="#FFFFFF" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const OrderSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => { navigate("/mobile/tables"); }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);


  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full flex justify-center" style={{ backgroundColor: "#000000" }} >
        <div className="relative w-full min-h-screen flex flex-col" style={{ backgroundColor: "#67AF7A" }} >
          <div className="flex-1 flex flex-col items-center justify-center gap-6 px-6">
            <CheckCircle />
            <h1 className="font-sansation font-bold text-white text-[24px]">
              Order Confirmed
            </h1>
            <button type="button" onClick={() => navigate("/mobile/tables")} className="mt-2 rounded-[6px] px-8 py-2.5 font-sansation font-bold text-[14px] tracking-[-0.28px] uppercase bg-white text-[#67AF7A] border-0">
              Done
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderSuccess;
